import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import KakaoAdfit1 from '../KakaoAdfit/KakaoAdfit1';
import KakaoAdfit2 from '../KakaoAdfit/KakaoAdfit2';
import KakaoAdfit3 from '../KakaoAdfit/KakaoAdfit3';
import KakaoAdfit4 from '../KakaoAdfit/KakaoAdfit4';
import axios from 'axios';
import { isMobile } from '../common/style';

const DebatePage: React.FC = () => {
  const [text, setText] = useState('');
  const [id, setId] = useState(0);
  const [data, setData] = useState<string[]>([]);

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `https://balancegame-34cd5-default-rtdb.firebaseio.com/debate.json`,
      );
      const responseData = response.data;
      if (responseData) {
        if (data.length !== 0) {
          for (let i = responseData.length - 1; i >= 0; i--) {
            data.pop();
          }
        }
        for (let i = responseData.length - 1; i >= 0; i--) {
          data.push(responseData[i].text);
        }
        setData(data);
        setId(responseData.length);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const textHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
    setText(event.target.value);
  };

  const handleKeyPress = async (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && text !== '') {
      try {
        await axios.put(
          `https://balancegame-34cd5-default-rtdb.firebaseio.com/debate/${id}.json`,
          {
            text,
          },
        );
        setText('');
        fetchData();
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <Center>
      <h1>밸런스게임</h1>
      <Container>
        <h2>밸런스게임 토론방</h2>
        <h5>다양한 주제로 자유롭게 이야기할 수 있는 토론방입니다</h5>
        <ScrollDiv>
          {data.length ? (
            data.map((item: string, index: number) => (
              <WriteDiv key={index}>
                <div>
                  <h3>{item}</h3>
                </div>
              </WriteDiv>
            ))
          ) : (
            <NoDiv>
              <h4>아직 글이 없어요</h4>
            </NoDiv>
          )}
        </ScrollDiv>
        <InputDiv>
          <input
            type="text"
            value={text}
            placeholder="입력 후 Enter 키를 누르면 전송됩니다."
            onChange={textHandler}
            onKeyPress={handleKeyPress}
          />
        </InputDiv>
        <h6 onClick={() => window.open('https://github.com/rlotr02')}>
          ⓒ 2023. rlotr02 All rights reserved.
        </h6>
      </Container>
      <KakaoAdfitDiv1>
        <KakaoAdfit1 />
      </KakaoAdfitDiv1>
      <KakaoAdfitDiv2>
        <KakaoAdfit2 />
      </KakaoAdfitDiv2>
      <KakaoAdfitDiv>
        <KakaoAdfit3 />
        <KakaoAdfit4 />
      </KakaoAdfitDiv>
    </Center>
  );
};

export default DebatePage;

const Center = styled.div`
  display: flex;
  position: fixed;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  left: 0;
  right: 0;
  transition: 0.5s;

  h1 {
    font-size: 27px;
    font-weight: 700;
    line-height: 150%;
    font-family: GmarketSansBold;
    color: #4da082;

    margin-top: 63px;
    margin-bottom: 40px;

    ${isMobile} {
      font-size: 22px;
      margin-top: 35px;
      margin-bottom: 30px;
    }
  }
`;

const Container = styled.div`
  margin-bottom: 30px;
  width: 800px;
  height: 530px;

  border-radius: 60px;
  border: 3px solid #3d6c5b;
  background: #dcf0e9;
  box-shadow: 4px 4px 4px 0px rgba(0, 0, 0, 0.2);
  position: relative;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${isMobile} {
    width: 300px;
    height: 350px;
    border-radius: 30px;
    margin-bottom: 15px;
    border: 2px solid #3d6c5b;
  }

  h2 {
    color: #3e6a55;
    font-family: GmarketSansBold;
    font-size: 23px;
    font-weight: 700;
    margin-top: 30px;

    ${isMobile} {
      font-size: 17px;
      margin-top: 17px;
    }
  }

  h5 {
    color: #39876a;
    font-family: GmarketSansMedium;
    font-size: 15px;
    font-weight: 500;
    margin-top: 8px;
    margin-bottom: 13px;

    ${isMobile} {
      font-size: 10px;
      margin-top: 4px;
      margin-bottom: 8px;
    }
  }

  h6 {
    color: #586f64;
    font-family: GmarketSansLight;
    font-size: 13px;
    font-weight: 300;
    margin-top: 13px;
    cursor: pointer;

    ${isMobile} {
      font-size: 10px;
      margin-top: 5px;
    }
  }
`;

const ScrollDiv = styled.div`
  width: 600px;
  height: 300px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;

  ${isMobile} {
    width: 230px;
    height: 213px;
    margin-bottom: 5px;
  }

  &::-webkit-scrollbar {
    width: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #b9d1c9;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;

const NoDiv = styled.div`
  width: 100%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;

  h4 {
    color: #328d61;
    font-family: GmarketSansMedium;
    font-size: 20px;
    font-weight: 500;

    ${isMobile} {
      font-size: 14px;
    }
  }
`;

const WriteDiv = styled.div`
  margin-bottom: 15px;
  padding-right: 10px;

  ${isMobile} {
    padding-right: 5px;
    margin-bottom: 6px;
  }

  div {
    float: left;
    padding: 15px 20px;
    background: #fff;
    text-align: left;

    ${isMobile} {
      padding: 8px 12px;
    }
  }

  h3 {
    color: #586f64;
    font-family: GmarketSansMedium;
    font-size: 16px;
    font-weight: 500;

    ${isMobile} {
      font-size: 12px;
    }
  }
`;

const InputDiv = styled.div`
  width: 550px;
  height: 60px;
  padding: 0 28px;
  border-radius: 23px;
  border: 3px solid #3d6c5b;
  background: #fff;
  display: flex;
  align-items: center;

  ${isMobile} {
    width: 220px;
    height: 30px;
    padding: 0 10px;
    border-radius: 10px;
    border: 2px solid #3d6c5b;
  }

  input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    color: #586f64;
    font-family: GmarketSansMedium;
    font-size: 17px;
    font-weight: 500;

    &::placeholder {
      color: #abb8b4;
    }

    ${isMobile} {
      font-size: 12px;
    }
  }
`;

const KakaoAdfitDiv1 = styled.div`
  margin-top: 100px;
  margin-right: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv2 = styled.div`
  margin-top: 100px;
  margin-left: 1000px;
  position: absolute;
`;

const KakaoAdfitDiv = styled.div`
  position: relative;
`;
